module.exports = __webpack_public_path__ + "img/symbol_app_04.c64cdd19.png";